import di        from 'dependeny-injection';
import container from './tags/register-container.riot';

di.riot.mount('binding');

const mtContainer = di.riot.component(container);
mtContainer(
    document.getElementById('root')
);
